// 场馆管理
export default [{
  path: '/site',
  component: () => import("../pages/siteManage/site.vue"),
  name: 'site',
  title: "场馆管理",
  meta: {
    title: "场馆管理"
  }
},{
  path: '/addSite',
  component: () => import("../pages/siteManage/addSite.vue"),
  name: 'addSite',
  title: "添加场馆",
  meta: {
    title: "添加场馆"
  }
}, {
  path: '/siteInfo',
  component: () => import("../pages/siteManage/siteInfo.vue"),
  name: 'siteInfo',
  title: "场馆详情",
  meta: {
    title: "场馆详情"
  }
}, {
  path: '/reserve',
  component: () => import("../pages/siteManage/reserve.vue"),
  name: 'reserve',
  title: "预约管理",
  meta: {
    title: "预约管理"
  }
}, {
  path: '/signIn',
  component: () => import("../pages/siteManage/signIn.vue"),
  name: 'signIn',
  title: "场馆签到",
  meta: {
    title: "场馆签到"
  }
}, {
  path: '/stadiumOrder',
  component: () => import("../pages/siteManage/stadiumOrder.vue"),
  name: 'stadiumOrder',
  title: "订单管理",
  meta: {
    title: "订单管理"
  }
}, ];
